<template>
  <div class="min-h-screen bg-gradient-to-br from-blue-900 via-blue-800 to-indigo-900 flex items-center justify-center">
    <div class="bg-white/10 backdrop-blur-md rounded-2xl p-8 shadow-2xl border border-white/20 max-w-md w-full mx-4">
      <div class="text-center">
        <!-- Logo -->
        <div class="mb-6">
          <div class="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
            <UserGroupIcon class="w-8 h-8 text-white" />
          </div>
          <h1 class="text-2xl font-bold text-white mb-2">Panel de Administración</h1>
          <p class="text-blue-100">Sistema Electoral</p>
        </div>

        <!-- Información de acceso -->
        <div class="mb-8 p-4 bg-blue-500/20 rounded-lg border border-blue-400/30">
          <div class="flex items-center justify-center mb-2">
            <LockClosedIcon class="w-5 h-5 text-blue-200 mr-2" />
            <span class="text-blue-100 font-medium">Acceso Seguro</span>
          </div>
          <p class="text-sm text-blue-200">
            Solo usuarios con rol de <strong>administrador</strong> pueden acceder al panel
          </p>
        </div>

        <!-- Botón de login -->
        <div class="space-y-4">
          <button
            @click="handleLogin"
            :disabled="isLoading"
            class="w-full bg-white/20 hover:bg-white/30 disabled:bg-white/10 text-white font-semibold py-3 px-6 rounded-lg border border-white/30 transition-all duration-200 flex items-center justify-center space-x-3 disabled:cursor-not-allowed"
          >
            <div v-if="isLoading" class="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
            <LockClosedIcon v-else class="w-5 h-5" />
            <span>{{ isLoading ? 'Redirigiendo...' : 'Iniciar Sesión Segura' }}</span>
          </button>

          <div v-if="error" class="bg-red-500/20 border border-red-400/30 rounded-lg p-3">
            <p class="text-red-200 text-sm">{{ error }}</p>
          </div>
        </div>

        <!-- Información adicional -->
        <div class="mt-8 text-xs text-blue-200 space-y-2">
          <p>🔐 Autenticación con Keycloak</p>
          <p>🛡️ Protocolo OAuth 2.0 + PKCE</p>
          <p>✨ Sin contraseñas almacenadas localmente</p>
        </div>

        <!-- Footer -->
        <div class="mt-8 pt-6 border-t border-white/10">
          <p class="text-xs text-blue-300">
            Sistema Electoral - Panel de Administración
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { UserGroupIcon, LockClosedIcon } from '@heroicons/vue/24/outline'

const router = useRouter()
const authStore = useAuthStore()

const error = ref('')
const isLoading = ref(false)

// Verificar si ya está autenticado al cargar la página
onMounted(async () => {
  try {
    // Verificar si ya está autenticado
    const isAuth = await authStore.checkAuth()
    
    if (isAuth && authStore.isAdmin) {
      console.log('✅ Usuario ya autenticado, redirigiendo al dashboard')
      router.push('/dashboard')
    }
  } catch (error) {
    console.log('ℹ️ Usuario no autenticado, mostrando login')
  }
})

async function handleLogin() {
  try {
    error.value = ''
    isLoading.value = true

    console.log('🔑 Iniciando proceso de login con Keycloak...')
    
    // Iniciar el flujo de login con Keycloak (redirige)
    await authStore.login()
    
    // Esta línea no se ejecutará porque login() redirige
    
  } catch (err: any) {
    console.error('❌ Error durante login:', err)
    error.value = err.message || 'Error durante el login'
    isLoading.value = false
  }
}
</script>
